import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'

import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import UserContext from '@/product/context/user/userContext'
import ReportContext from '@/product/context/report/reportContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import CustomCommonContext from '../../custom/context/common/commonContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'
import '../Dashboard/Dashboard.css'
import { Button } from '@mui/material'
import * as Yup from 'yup'
import UserManage from './Custom'
import BuyerBids from './BuyerFields'
import moment from 'moment'
import { Buffer } from 'buffer'
const UserView = (props) => {
    const [randomVariable, setRandomVariable] = useState()
    const alertContext = useContext(AlertContext)
    const userContext = useContext(UserContext)
    const reportContext = useContext(ReportContext)

    const customCommonContext = useContext(CustomCommonContext)
    const {
        alldata_all_dropdown,
        restockingFeeUpdate,
        responseStatus,
        clearResponse,
    } = customCommonContext

    const authContext = useContext(AuthContext)
    const { user } = authContext

    const [isLoading, setIsLoading] = useState(true)
    const { getAllExportDownload } = reportContext
    const history = useHistory()
    const { setAlert } = alertContext
    const {
        all_users,
        changeUserStatus,
        getAllUsers,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = userContext
    const [changeStatus, setChangeStatus] = React.useState(false)
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        user_type: 0,
    })
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
        formikSelection.handleReset()
    }

    const toggleFullScreenPopup = (popup, status, id, user_type) => {
        if (popup) {
            setManage({ popup, status, id, user_type })
        } else {
            setManage({ popup, status: 'new', id: 0, user_type: 0 })
        }
    }

    let action =
        props.match.params.action !== 'all' ? props.match.params.action : null

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            onlyCount: true,
            filters: {
                action: {
                    value: action ? action.toString() : null,
                    type: 'in',
                    field: 'u.status',
                },
                email: {
                    value: '',
                    type: 'like',
                    field: 'u.email',
                },
                user_id: {
                    value: '',
                    type: 'like',
                    field: 'u.id',
                },
                first_name: {
                    value: '',
                    type: 'like',
                    field: 'u.first_name',
                },
                last_name: {
                    value: '',
                    type: 'like',
                    field: 'u.last_name',
                },
                username: {
                    value: '',
                    type: 'like',
                    field: 'u.username',
                },
                admin: {
                    value: '0',
                    type: 'in',
                    field: 'u.admin',
                },
                tax_doc: {
                    value: '',
                    type: 'in',
                    field: 'cu.tax_doc_status',
                },
                tax_number: {
                    value: '',
                    type: 'in',
                    field: 'cu.tax_number',
                },
                dealer_tax_status: {
                    value: '',
                    type: 'in',
                    field: 'cu.dealer_tax_status',
                },
                dealer_license_no: {
                    value: '',
                    type: 'in',
                    field: 'cu.dealer_license_no',
                },
                restocking_fee_status: {
                    value: '',
                    type: 'in',
                    field: 'cu.restocking_fee_status',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            let value = values
            if (value.filters.tax_doc.value == 1) {
                value.filters.tax_doc.value = 1
                value.filters.tax_number.type = 'in'
                value.filters.tax_number.value = ''
            } else if (value.filters.tax_doc.value == '0') {
                value.filters.tax_doc.value = '0'
                value.filters.tax_number.type = 'notnull'
                value.filters.tax_number.value = ''
            } else {
                value.filters.tax_doc.value = ''
                value.filters.tax_number.type = 'in'
                value.filters.tax_number.value = ''
            }
            let randomVariableUpdate = Math.random()
            setRandomVariable(randomVariableUpdate)

            if (value.filters.dealer_tax_status.value == 1) {
                value.filters.dealer_tax_status.value = 1
                value.filters.dealer_license_no.type = 'in'
                value.filters.dealer_license_no.value = ''
            } else if (value.filters.dealer_tax_status.value == '0') {
                value.filters.dealer_tax_status.value = '0'
                value.filters.dealer_license_no.type = 'notnull'
                value.filters.dealer_license_no.value = ''
            } else {
                value.filters.dealer_tax_status.value = ''
                value.filters.dealer_license_no.type = 'in'
                value.filters.dealer_license_no.value = ''
            }
            getAllUsers(value, randomVariableUpdate)
        },
    })

    useEffect(() => {
        if (
            randomVariable == all_users?.from ||
            all_users?.from == 'UserManagement'
        ) {
            setIsLoading(false)
        }

        if (all_users) {
            setTableBody(all_users.records.length ? all_users.records : [])
        }
    }, [all_users])

    useEffect(() => {
        let randomVariableUpdate = Math.random()
        setRandomVariable(randomVariableUpdate)
        setTableBody([])
        setIsLoading(true)
        formik.values.filters.action.value = action
        formik.values.page = 1
        formik.values.filters.email.value = ''
        formik.values.filters.user_id.value = ''
        formik.values.filters.first_name.value = ''
        formik.values.filters.last_name.value = ''

        getAllUsers(formik.values, randomVariableUpdate)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])
    useEffect(() => {
        if (responseStatus && responseStatus.from === 'restockingFeeUpdate') {
            if (responseStatus.status === 'success') {
                setAlert('Successfully Updated', 'success')
                changeChangeStatus()
                setIsLoading(false)
                let randomVariableUpdate = Math.random()
                setRandomVariable(randomVariableUpdate)
                getAllUsers(formik.values, randomVariableUpdate)
            } else {
                setAlert(
                    responseStatus.message || 'Try after sometimes!',
                    responseStatus.status || 'error'
                )
            }

            clearResponse()
        }
    }, [responseStatus])
    const onClickEdit = (id, type) => {
        handleRedirectInternal(history, `users/view/${id}`)
    }

    const onClickSwitchUser = (id) => {
        let btoa = Buffer.from(id.toString(), 'binary').toString('base64')
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}switch?user_id=${btoa}`,
            '_blank'
        )
    }

    const validationArray = Yup.object({
        reject_notes: Yup.string().when(['additionalUpdate', 'action'], {
            is: (a, b) => a && b !== 'restocking_fee',
            then: Yup.string().required('Required'),
        }),
        reinstate_days: Yup.string().when(['action'], {
            is: (a) => a === 'deactivate',
            then: Yup.string().required('Required'),
        }),
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            user_id: '',
            reject_notes: '',
            reinstate_date: '',
            reinstate_days: '',
            additionalUpdate: true,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.action === 'rejected') {
                changeUserStatus(values)
            } else if (values.action === 'suspended') {
                changeUserStatus(values)
            } else if (values.action === 'active') {
                changeUserStatus({
                    action: values.action,
                    user_id: values.user_id,
                    reject_notes: '',
                    additionalUpdate: true,
                })
            } else if (values.action === 'deactivate') {
                if (
                    values.reinstate_days !== '' &&
                    values.reinstate_days !== 'Never'
                ) {
                    let endDate = new Date()
                    endDate.setDate(
                        endDate.getDate() + parseInt(values.reinstate_days)
                    )
                    values.reinstate_date =
                        endDate.getFullYear() +
                        '-' +
                        (parseInt(endDate.getMonth()) + 1) +
                        '-' +
                        endDate.getDate()
                } else if (values.reinstate_date !== '') {
                    values.reinstate_date = moment(
                        values.reinstate_date
                    ).format('YYYY-MM-DD')
                }
                console.log(values, 'vallingg')
                changeUserStatus(values)
            } else if (values.action === 'restocking_fee') {
                restockingFeeUpdate({
                    user_id: values.user_id,
                    restocking_fee_status: 0,
                    removeRestockingFee: true,
                })
                // changeUserStatus({
                //     user_id: values.user_id,
                //     action: values.action,
                //     additionalUpdate: true,
                //     restocking_fee_status: '0',
                // })
            }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.user_id = data
        formikSelection.values.additionalUpdate =
            action === 'deactivate' ||
            action === 'rejected' ||
            action === 'suspended' ||
            action === 'restocking_fee'
                ? true
                : false
        formikSelection.values.reject_notes = ''
        formikSelection.values.reinstate_days = ''
        formikSelection.values.reinstate_date = ''
        if (
            action === 'active' ||
            action === 'deactivate' ||
            action === 'rejected' ||
            action === 'suspended' ||
            action === 'restocking_fee'
        ) {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []

        if (user?.emp_type !== 'seller') {
            actionPush.push({
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Edit User',
            })
        }

        actionPush.push({
            buttonType: 'visibility',
            clickType: 'switchuser',
            onclick: onClickSwitchUser,
            tooltipTitle: 'Switch user',
        })

        return actionPush
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Bidder #',
            filterable: true,
            filterField: 'u.id',
        },
        {
            field: 'first_name',
            type: 'customLabelColor',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'First Name',
            filterable: true,
            filterField: 'u.first_name',
            labelColorFieldCheck: 'restocking_fee_status',
            successColor: 'red',
            failColor: 'green',
        },
        {
            field: 'last_name',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Last Name',
            filterable: true,
            filterField: 'u.last_name',
        },
        {
            field: 'username',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Username',
            filterable: true,
            filterField: 'u.username',
        },
        {
            field: 'email',
            type: 'hyperlink',
            clickID: 'id',
            onclick: onClickEdit,
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Email',
            filterable: true,
            filterField: 'u.email',
        },
        {
            field: 'phone',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Phone Number',
            filterable: true,
            filterField: 'u.phone',
        },
        {
            field: 'companyname',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Company Name',
            filterable: true,
            filterField: 'u.companyname',
        },
        {
            field: 'tax_number',
            type: 'customLabelColor',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Resale License #',
            filterable: true,
            filterField: 'cu.tax_number',
            labelColorFieldCheck: 'tax_doc_status',
            successColor: 'green',
            failColor: 'red',
        },
        {
            field: 'additional_phone',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Additional Phone number',
            filterable: true,
            filterField: 'cu.additional_phone',
        },
        {
            field: 'address1',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Address',
            filterable: true,
            filterField: 'u.address1',
        },
        {
            field: 'city',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'City',
            filterable: true,
            filterField: 'u.city',
        },
        {
            field: 'state',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'State',
            filterable: true,
            filterField: 'u.state',
        },
        {
            field: 'country',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Country',
            filterable: true,
            filterField: 'u.country',
        },
        {
            field: 'zip',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Zip code',
            filterable: true,
            filterField: 'u.zip',
        },
        {
            field: 'last_login',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Last Login',
            filterable: true,
            filterField: 'u.last_login',
        },
        {
            field: 'status',
            type: 'singleSelect',
            valueOptions: [
                'active',
                'email_unverified',
                'deactivate',
                'rejected',
                'suspended',
            ],
            filterable: true,
            filterField: 'u.status',
            sort: true,
            firstChild: false,
            capitalize: true,
            disablePadding: false,
            label: 'Status',
        },
    ]
    if (action === 'deactivate' || action === 'rejected') {
        tableValues.push({
            field: 'reject_notes',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Notes',
            filterable: true,
            filterField: 'it.reject_notes',
        })
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickID: 'id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Email ',
                placeholder: 'Enter Email',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'email',
                filter: true,
            },
            // {
            //     label: 'Bidder # ',
            //     placeholder: 'Enter Bidder #',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'user_id',
            //     filter: true,
            // },
            {
                label: 'Username',
                placeholder: 'Enter Username',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'username',
                filter: true,
            },
            {
                label: 'First Name',
                placeholder: 'Enter First Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'first_name',
                filter: true,
            },
            {
                label: 'Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'last_name',
                filter: true,
            },
            {
                label: 'Resale Status',
                placeholder: 'Select Resale Status',
                class: `col-md-4 col-sm-6 col-12`,
                type: 'select',
                name: 'tax_doc',
                options: [
                    { value: 1, show: 'Verified' },
                    { value: '0', show: 'Not Verified' },
                ],
                filter: true,
                native: true,
            },
            {
                label: 'Restocking Fee Status',
                placeholder: 'Select Restocking Fee Status',
                class: `col-md-4 col-sm-6 col-12`,
                type: 'select',
                name: 'restocking_fee_status',
                options: [
                    { value: 1, show: 'Users with Restocking Fee Applied' },
                    {
                        value: '0',
                        show: 'Users without Restocking Fee Applied',
                    },
                ],
                filter: true,
                native: true,
            },
        ],
    }

    const tableActions = []

    if (action === 'active' || action === 'suspended') {
        tableActions.push({
            label: 'Move to De-activate',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactivate',
        })
    }
    // if (action === 'active') {
    //     tableActions.push({
    //         label: 'Move to Suspended',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'suspended',
    //     })
    // }

    tableActions.push({
        label: 'Remove Restocking Fee Status',
        icon: <span className="material-icons">free_cancellation</span>,
        onclick: onSelectMultiProducts,
        type: 'restocking_fee',
    })

    if (
        action === 'deactivate' ||
        action === 'unverified' ||
        action === 'suspended'
    ) {
        tableActions.push({
            label: 'Move to Activate',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        })
    }

    // if (action === 'unverified') {
    //     tableActions.push({
    //         label: 'Move to Rejected',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'rejected',
    //     })
    // }

    if (action === 'all' || !action) {
        tableActions.push(
            {
                label: 'Move to De-activate',
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactivate',
            },
            // {
            //     label: 'Move to Suspended',
            //     icon: <span className="material-icons">cancel</span>,
            //     onclick: onSelectMultiProducts,
            //     type: 'suspended',
            // },
            {
                label: 'Move to Activate',
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
            }
            // {
            //     label: 'Move to Rejected',
            //     icon: <span className="material-icons">cancel</span>,
            //     onclick: onSelectMultiProducts,
            //     type: 'rejected',
            // }
        )
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.status === 'success') {
                if (responseStatusUser.from === 'changeStatus') {
                    setChangeStatus(false)
                    let randomVariableUpdate = Math.random()
                    setRandomVariable(randomVariableUpdate)
                    getAllUsers(formik.values, randomVariableUpdate)
                }
                if (responseStatusUser.from === 'userAction') {
                    toggleFullScreenPopup(false)
                    let randomVariableUpdate = Math.random()
                    setRandomVariable(randomVariableUpdate)
                    getAllUsers(formik.values, randomVariableUpdate)
                }
            }
        }
    }, [responseStatusUser])

    const rejectNotes = {
        formik: formikSelection,
        data: [
            {
                label: 'Justification Notes',
                placeholder: 'Enter Justification Notes',
                class: `col-12 ${
                    formikSelection.values.additionalUpdate ? '' : 'd-none'
                }`,
                type: 'textarea',
                name: 'reject_notes',
                filter: true,
            },
            {
                label: 'Time Limit',
                placeholder: 'Select Time Limit',
                class: `col-12 ${
                    formikSelection.values.additionalUpdate &&
                    formikSelection.values.action === 'deactivate'
                        ? ''
                        : 'd-none'
                }`,
                type: 'select',
                name: 'reinstate_days',
                options: [
                    { value: '30', show: '30 Days' },
                    { value: '90', show: '90 Days' },
                    { value: '180', show: '180 Days' },
                    { value: 'Never', show: 'Never' },
                ],
            },
            // {
            //     label: 'Activation Date',
            //     placeholder: 'Enter Activation Date',
            //     class: `col-12 ${
            //         formikSelection.values.additionalUpdate &&
            //         formikSelection.values.action === 'deactivate'
            //             ? ''
            //             : 'd-none'
            //     }`,
            //     type: 'date',
            //     name: 'reinstate_date',
            // },
        ],
    }
    const userExportFields = [
        { name: 'Bidder #', field: 'id', type: '' },
        {
            name: 'First Name',
            field: 'first_name',
            type: '',
        },
        {
            name: 'Last Name',
            field: 'last_name',
            type: '',
        },
        { name: 'Email Address', field: 'email', type: '' },
        { name: 'Company / Organization', field: 'companyname', type: '' },
        // {
        //     name: 'License Expiry date',
        //     field: 'license_expiry_date',
        //     type: '',
        // },
        // { name: 'Government Photo ID', field: 'govt_photo_id', type: '' },
        // { name: 'Passport', field: 'passport', type: '' },
        { name: 'Mobile number', field: 'phone', type: '' },
        {
            name: 'Additional Phone number',
            field: 'additional_phone',
            type: '',
        },
        // { name: 'Phone Number Type', field: 'phone_type2', type: '' },
        { name: 'Address', field: 'address1', type: '' },
        { name: 'City', field: 'city', type: '' },
        { name: 'State', field: 'state', type: '' },
        { name: 'Country', field: 'country', type: '' },
        { name: 'Zip code', field: 'zip', type: '' },
        { name: 'Resale Number', field: 'tax_number', type: '' },
        // { name: 'Dealer License Number', field: 'dealer_license_no', type: '' },
        // {
        //     name: 'Interested Category',
        //     field: 'interested_categories',
        //     type: '',
        // },
        // { name: 'Email preferences', field: 'email_pref', type: '' },
        // { name: 'License Expiration Date', field: 'license_expiry', type: '' },
        // {
        //     name: 'Resale Exemption Verified',
        //     field: 'tax_doc_status',
        //     type: '',
        // },
        // {
        //     name: 'Dealer License Verified',
        //     field: 'dealer_tax_status',
        //     type: '',
        // },
        // { name: 'Social Security Number on File', field: 'ssn', type: '' },
        { name: 'How Did you Find Us', field: 'find_source', type: '' },

        {
            name: 'Created By',
            field: 'created_username',
            type: '',
        },
        {
            name: ' Created Date',
            field: 'created_at',
            type: 'datetime',
        },
        {
            name: 'Last Login',
            field: 'last_login',
            type: 'datetime',
        },
        { name: 'Status', field: 'status', type: 'capitalize' },
    ]

    return (
        <Layout>
            <div className="dashboard userManagement">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                {user?.emp_type === 'super_admin' ||
                user?.emp_type === 'admin' ? (
                    <div className="miscActions d-flex justify-content-between align-items-center mt-4 flex-wrap">
                        <div>
                            <Button
                                id="userManage_add"
                                variant="outlined"
                                className="btnOutlined mr-1"
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        `add/user/new`
                                    )
                                }
                            >
                                <span className="material-icons">
                                    person_add_alt_1
                                </span>
                                Add Individual User
                            </Button>
                        </div>
                        <Button
                            id="userManage_report"
                            variant="outlined"
                            className="exportAllBtn"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_user_management`,
                                    fields: userExportFields,
                                    isDefault: false,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>
                ) : null}
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    columnVisibilityModel={{
                        driver_license: false,
                        license_expiry_date: false,
                        govt_photo_id: false,
                        passport: false,
                        additional_phone: false,
                        phone_type2: false,
                        address1: false,
                        city: false,
                        state: false,
                        country: false,
                        zip: false,
                        tax_number: false,
                        dealer_license_no: false,
                        license_expiry: false,
                        ssn: false,
                    }}
                    tableActions={tableActions}
                    allData={all_users}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllUsers}
                    columnStorageVariable={'table_user_management'}
                />
            </div>
            {/* <BuyerBids
                data={manage}
                function={toggleFullScreenPopup}
                action={action}
            /> */}
            <CustomDialog
                title={
                    formikSelection.values.action === 'restocking_fee'
                        ? 'Remove Restocking Fee Status'
                        : 'Change user status'
                }
                open={changeStatus}
                function={changeChangeStatus}
            >
                {formikSelection.values.action === 'restocking_fee' ? (
                    <h5>
                        Are you sure you want to Remove Restocking Fee Status ?
                    </h5>
                ) : (
                    <h5>Are you sure you want to change the status</h5>
                )}

                {formikSelection.values.action !== 'restocking_fee' ? (
                    <div className="row">{mapData(rejectNotes)}</div>
                ) : null}
                <div className="actionWrapper">
                    <Button
                        id="userManage_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="userView_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default UserView
